const CANONICAL_TICKERS = [
    "BTC",
    "ETH",
    "XRP",
    "ADA",
    "AVAX",
    "BNB",
    "HBAR",
    "LTC",
    "SUI",
    "SOL",
];

const ALIAS_TO_CANONICAL = {
    BTC: "BTC",
    BITCOIN: "BTC",
    ETH: "ETH",
    ETHEREUM: "ETH",
    XRP: "XRP",
    RIPPLE: "XRP",
    ADA: "ADA",
    CARDANO: "ADA",
    AVAX: "AVAX",
    "AVALANCHE-2": "AVAX",
    BNB: "BNB",
    BINANCECOIN: "BNB",
    HBAR: "HBAR",
    "HEDERA-HASHGRAPH": "HBAR",
    LTC: "LTC",
    LITECOIN: "LTC",
    SUI: "SUI",
    SOL: "SOL",
    SOLANA: "SOL",
};

const ALIAS_MAP = Object.entries(ALIAS_TO_CANONICAL).reduce((acc, [key, value]) => {
    acc[key] = value;
    acc[key.toLowerCase()] = value;
    return acc;
}, {});

const RANKING = new Map(CANONICAL_TICKERS.map((sym, idx) => [sym, idx]));

export function resolveCanonicalSymbol(value) {
    const raw = String(value || "").trim();
    if (!raw) return null;
    const upper = raw.toUpperCase().replace(/[^A-Z0-9-]/g, "");
    const marketBase = upper.replace(/(?:USDT|USDC|BUSD|USD)$/, "");
    return ALIAS_MAP[raw] || ALIAS_MAP[upper] || ALIAS_MAP[marketBase] || ALIAS_MAP[raw.toLowerCase()] || null;
}

export function sortCanonicalSymbols(symbols = []) {
    return [...symbols].sort((a, b) => {
        const first = RANKING.has(a) ? RANKING.get(a) : Number.POSITIVE_INFINITY;
        const second = RANKING.has(b) ? RANKING.get(b) : Number.POSITIVE_INFINITY;
        if (first !== second) return first - second;
        return a.localeCompare(b);
    });
}

export { CANONICAL_TICKERS, ALIAS_TO_CANONICAL };

